import { FC } from 'react';

import { IconProps } from './types';

export const BugHandleV4Icon: FC<IconProps> = () => {
  return (
    <svg
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20 5C18.3424 5 16.7527 5.65848 15.5806 6.83058C14.4085 8.00269 13.75 9.5924 13.75 11.25V12.5H26.25V11.25C26.25 9.5924 25.5915 8.00269 24.4194 6.83058C23.2473 5.65848 21.6576 5 20 5ZM11.25 11.25V12.5H6.25C5.58696 12.5 4.95107 12.7634 4.48223 13.2322C4.01339 13.7011 3.75 14.337 3.75 15V31.875C3.75 34.9279 6.32214 37.5 9.375 37.5H30.625C33.641 37.5 36.25 35.0618 36.25 31.9727V15C36.25 14.337 35.9866 13.7011 35.5178 13.2322C35.0489 12.7634 34.413 12.5 33.75 12.5H28.75V11.25C28.75 8.92936 27.8281 6.70376 26.1872 5.06282C24.5462 3.42187 22.3206 2.5 20 2.5C17.6794 2.5 15.4538 3.42187 13.8128 5.06282C12.1719 6.70376 11.25 8.92936 11.25 11.25ZM6.25 15H12.5H27.5H33.75V31.9727C33.75 33.6085 32.334 35 30.625 35H9.375C7.70286 35 6.25 33.5471 6.25 31.875L6.25 15ZM13.75 17.5C13.75 16.8096 13.1904 16.25 12.5 16.25C11.8096 16.25 11.25 16.8096 11.25 17.5V18.75C11.25 21.0706 12.1719 23.2962 13.8128 24.9372C15.4538 26.5781 17.6794 27.5 20 27.5C22.3206 27.5 24.5462 26.5781 26.1872 24.9372C27.8281 23.2962 28.75 21.0706 28.75 18.75V17.5C28.75 16.8096 28.1904 16.25 27.5 16.25C26.8096 16.25 26.25 16.8096 26.25 17.5V18.75C26.25 20.4076 25.5915 21.9973 24.4194 23.1694C23.2473 24.3415 21.6576 25 20 25C18.3424 25 16.7527 24.3415 15.5806 23.1694C14.4085 21.9973 13.75 20.4076 13.75 18.75V17.5Z"
        fill="#CEFFF4"
        fillOpacity="0.5"
      />
    </svg>
  );
};